import { HopePepe_Contract_ABI, HopePepe_Contract_Address, ROUTER_Contract_Address, USDC_Contract_Abi, USDC_Contract_Address, USDT_Contract_Abi, USDT_Contract_Address, WBTC_Contract_Abi, WBTC_Contract_Address } from "../utilies/constant";
import useGetAmountOut from "./useGetAmountOut";


const useTokenAllowance = (fromValue,toValue, address) => {
  const { tokenBlnc: USDTAllowance,refetch } = useGetAmountOut(
    USDT_Contract_Address,
    USDT_Contract_Abi,
    fromValue,
    "allowance",
    [address,ROUTER_Contract_Address]
  );

  const { tokenBlnc: USDCAllowance } = useGetAmountOut(
    USDC_Contract_Address,
    USDC_Contract_Abi,
    fromValue,
    "allowance",
    [address,ROUTER_Contract_Address]
  );

  const { tokenBlnc: HOPEAllowance } = useGetAmountOut(
    HopePepe_Contract_Address,
    HopePepe_Contract_ABI,
    fromValue,
    "allowance",
    [address,ROUTER_Contract_Address]
  );

  const { tokenBlnc: WBTCAllowance } = useGetAmountOut(
    WBTC_Contract_Address,
    WBTC_Contract_Abi,
    fromValue,
    "allowance",
    [address,ROUTER_Contract_Address]
  );

  return { USDTAllowance, USDCAllowance, HOPEAllowance,WBTCAllowance,refetch };
};

export default useTokenAllowance;
